import api from './api';

export interface FiltrosFinanceiro {
  tipo?: string;
  dataInicio?: string;
  dataFim?: string;
  empresaId?: string | number;
}

export interface LancamentoFinanceiro {
  tipo: 'entrada' | 'saida';
  valor: number;
  descricao: string;
  data: string;
  observacao?: string;
  empresaId: number;
}

export const criarLancamento = async (dados: LancamentoFinanceiro) => {
  const response = await api.post('/financeiro', dados);
  return response.data;
};

export const listarLancamentos = async (filtros: FiltrosFinanceiro = {}) => {
  const params: FiltrosFinanceiro = {};
  if (filtros.tipo) params.tipo = filtros.tipo;
  if (filtros.dataInicio) params.dataInicio = filtros.dataInicio;
  if (filtros.dataFim) params.dataFim = filtros.dataFim;
  if (filtros.empresaId) params.empresaId = filtros.empresaId;
  const response = await api.get('/financeiro', { params });
  return response.data;
};

export const receitaLiquida = async (dataInicio: string, dataFim: string) => {
  const response = await api.get('/financeiro/receita', { params: { dataInicio, dataFim } });
  return response.data;
};

export const removerLancamento = async (id: number) => {
  await api.delete(`/financeiro/${id}`);
}; 